import React from 'react';
import {SETTINGS_FILTERS, SETTINGS_PERIOD, SETTINGS_WORKPLACES} from './types';
import PeriodSettings from './PeriodSettings';
import WorkplacesSettings from './WorkplacesSettings';
import FilterSettings from './FilterSettings';
import getPeriodAnchor from "../../utils/getPeriodAnchor";

const Settings = ({type, ...props}) => {
  switch (type) {
    case SETTINGS_PERIOD:
      return <PeriodSettings {...props} />;
    case SETTINGS_WORKPLACES:
      return <WorkplacesSettings {...props} />;
    case SETTINGS_FILTERS:
      return <FilterSettings {...props} periodAnchor={getPeriodAnchor()} />;
    default:
      return null;
  }
};

export default Settings;
